import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "position-relative" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["srcset"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["alt"]
const _hoisted_7 = {
  key: 2,
  class: "position-absolute top-0 start-0 m-3"
}
const _hoisted_8 = {
  key: 0,
  class: "badge bg-danger",
  style: {"font-size":"1.5rem"}
}
const _hoisted_9 = { class: "card-body p-4" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "fw-bolder" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }

import { ref, computed } from 'vue';
    import { ArticleViewModel } from '@/types/ArticleViewModel';
    import { CategoryViewModel } from '@/types/CategoryViewModel';
    import { useRootStore } from '@/store/root.store';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ArticleCard',
  props: {
    article: null,
    heightClass: null
  },
  setup(__props: any) {

const props = __props as { article: ArticleViewModel, heightClass: string }

    const rootStore = useRootStore();

    
    const article = ref<ArticleViewModel>(props.article);

    const selectedCategory = computed(() => {
        return rootStore.categories.length
            ? rootStore.categories.find(x => x.id === article.value.categoryId)
            : {} as CategoryViewModel;
    });

    function getClass() {
        return props.heightClass;
    }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: { name:`Article-${_unref(selectedCategory)?.urlSlug}`, params: { slug: article.value.urlSlug } },
    custom: ""
  }, {
    default: _withCtx(({ navigate }) => [
      _createElementVNode("div", {
        class: _normalizeClass(["card shadow", getClass()]),
        onClick: navigate
      }, [
        _createElementVNode("div", _hoisted_2, [
          (article.value.files.length)
            ? (_openBlock(), _createElementBlock("picture", _hoisted_3, [
                _createElementVNode("source", {
                  srcset: `/images/${article.value.files[0].name}-thumbnail.webp`,
                  type: "image/webp"
                }, null, 8, _hoisted_4),
                _createElementVNode("img", {
                  class: "card-img-top",
                  src: `/images/${article.value.files[0].name}-thumbnail.jpg`,
                  alt: `Bild för ${article.value.modelName} ${article.value.name}`
                }, null, 8, _hoisted_5)
              ]))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: "card-img-top",
                src: "https://dummyimage.com/465x390/dee2e6/6c757d.jpg",
                alt: `${article.value.name} - bild`
              }, null, 8, _hoisted_6)),
          (article.value.isSold && article.value.categoryId == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (article.value.isSold)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "SÅLD"))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h4", _hoisted_11, [
              (_unref(selectedCategory).id === 2)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(article.value.modelName) + " ", 1))
                : _createCommentVNode("", true),
              _createTextVNode(_toDisplayString(article.value.name), 1)
            ]),
            (_unref(selectedCategory).id === 2)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(article.value.priceDisplay), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ], 10, _hoisted_1)
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})